import StaticPage from "./StaticPage"

export default StaticPage
